import { createTheme } from '@mui/material';
import { rgba } from './utils';
import { theme } from './theme';
import { tokenPxToNumber, tokens } from './tokens';

export const muiTheme = createTheme({
   typography: {
      fontFamily: tokens.font.family,
      fontSize: tokenPxToNumber(tokens.font.size.lg),
      h1: { fontSize: tokens.font.size['3xl'] },
      h2: { fontSize: tokens.font.size.xxl },
      h3: { fontSize: tokens.font.size.xl },
      h4: { fontSize: tokens.font.size.lg },
      h5: { fontSize: tokens.font.size.md },
      h6: { fontSize: tokens.font.size.sm },
   },
   palette: {
      primary: {
         main: theme.colors.border.focus,
         light: rgba(theme.colors.border.focus, 0.8),
      },
      secondary: {
         main: tokens.brand.yellow,
      },
      error: {
         main: theme.colors.state.error,
      },
      warning: {
         main: theme.colors.state.warning,
      },
      success: {
         main: theme.colors.state.success,
      },
      info: {
         main: theme.colors.state.info,
      },
      background: {
         default: theme.colors.bg.primary,
         paper: theme.colors.bg.secondary,
      },
      text: {
         primary: theme.colors.text.primary,
         secondary: theme.colors.text.secondary,
         disabled: theme.colors.text.disabled,
      },
   },
   shape: {
      borderRadius: tokenPxToNumber(tokens.radius.md),
   },
   spacing: 8,
   components: {
      MuiButton: {
         styleOverrides: {
            root: {
               borderRadius: tokens.radius.md,
               textTransform: 'none',
               fontSize: tokens.font.size.sm,
               transition: tokens.transition.fast,
            },
            containedPrimary: {
               backgroundColor: theme.colors.border.focus,
               '&:hover': {
                  backgroundColor: rgba(theme.colors.border.focus, 0.85),
               },
            },
         },
      },
      MuiPaper: {
         styleOverrides: {
            root: {
               borderRadius: tokens.radius.lg,
               boxShadow: tokens.shadow.md,
            },
         },
      },
      MuiMenuItem: {
         styleOverrides: {
            root: {
               fontSize: tokens.font.size.sm,
               '&.Mui-selected': {
                  backgroundColor: theme.colors.bg.tertiary,
               },
               '&:hover': {
                  backgroundColor: theme.colors.bg.secondary,
               },
            },
         },
      },
      MuiSelect: {
         styleOverrides: {
            select: {
               fontSize: tokens.font.size.sm,
            },
         },
      },
      MuiInputLabel: {
         styleOverrides: {
            root: {
               fontSize: tokens.font.size.md,
               color: theme.colors.text.secondary,
            },
         },
      },
      MuiInputBase: {
         styleOverrides: {
            root: {
               fontSize: tokens.font.size.md,
               '& input': {
                  padding: tokens.space.md,
               },
            },
         },
      },
      MuiAutocomplete: {
         styleOverrides: {
            root: {
               '& .MuiInputBase-root': {
                  paddingTop: 0,
                  paddingBottom: 0,
               },
            },
            option: {
               fontSize: tokens.font.size.md,
               backgroundColor: `${theme.colors.bg.primary} !important`,
               '&.Mui-focused': {
                  backgroundColor: `${theme.colors.bg.secondary} !important`,
               },
               '&[aria-selected="true"]': {
                  backgroundColor: `${theme.colors.bg.tertiary} !important`,
               },
            },
            noOptions: {
               fontSize: tokens.font.size.md,
               color: theme.colors.text.tertiary,
            },
         },
      },
   },
});
